<div class="flex flex-col gap-5">
    <div class="w-full grid grid-cols-2 gap-5">
        <bb-field label="Brief title" [required]="true" class="sm:col-span-1"
            hint="Title Case works best — e.g. &quot;Copilot, Your Everyday AI Sidekick&quot;.">
            <input [value]="service.basicInfoModel().briefTitle" (input)="setTitle($any($event.target).value)"
                placeholder="Give this brief a punchy name"
                class="w-full rounded-md border border-border bg-card px-3.5 py-2.5 text-base outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground" />
        </bb-field>
        <bb-field label="Campaign" class="sm:col-span-1"
            hint="Optional — group this brief under a campaign, or leave as No Campaign.">
            @if (campaignStore.allCampaigns()) {
            <el-select id="campaign-select" name="selected" [value]="campaignStore.campaignSelectValue()" class="block">
                <!-- <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn"> -->
                <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-spacious-btn">
                    <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                        @if (service.selectedCampaign()) {
                        <img [src]="service.selectedCampaign()?.campaignPhoto ? imageService.getImageSource(service.selectedCampaign()?.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                            alt=""
                            class="size-5 shrink-0 rounded-full dark:bg-gray-700 bg-gray-300 outline -outline-offset-1 outline-white/10" />
                        <p class="m-0 block truncate">{{ service.selectedCampaign()?.campaignName }}</p>
                        } @else {
                        <div
                            class="size-5 shrink-0 rounded-full outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5" aria-hidden="true">
                                <path
                                    d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                <path d="m9.5 10.5 5 5" />
                                <path d="m14.5 10.5-5 5" />
                            </svg>
                        </div>
                        <p class="m-0 block truncate text-base">No Campaign</p>
                        }
                    </el-selectedcontent>
                    <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4">
                        <path
                            d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                </button>

                <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                    <!-- Add Campaign Option -->
                    <el-option (click)="campaignStore.onAddCampaignClick($event)"
                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                        <div class="flex items-center">
                            <div class="size-5 shrink-0 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M5 12h14" />
                                    <path d="M12 5v14" />
                                </svg>
                            </div>
                            <p class="m-0 ml-3 block truncate font-normal group-aria-selected/option:font-semibold">Add
                                Campaign</p>
                        </div>
                        <span
                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden"
                            aria-hidden="true">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                    </el-option>
                    <!-- Add Campaign Option - END -->

                    <!-- No Campaign Selected -->
                    <el-option [value]="campaignStore.campaignSelectNoneValue" (click)="campaignStore.clearCampaign()"
                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                        <div class="flex items-center">
                            <div class="size-5 shrink-0 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path
                                        d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                    <path d="m9.5 10.5 5 5" />
                                    <path d="m14.5 10.5-5 5" />
                                </svg>
                            </div>
                            <p class="m-0 ml-3 block truncate font-normal group-aria-selected/option:font-semibold">No
                                Campaign</p>
                        </div>
                        <span
                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden"
                            aria-hidden="true">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                    </el-option>
                    <!-- No Campaign Selected - END -->
                    @for (campaign of campaignStore.allCampaigns(); track campaign.id) {
                    <el-option [value]="campaign.id" (click)="campaignStore.selectCampaign(campaign)"
                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                        <div class="flex items-center">
                            <img class="size-5 shrink-0 rounded-full"
                                [src]="campaign.campaignPhoto ? imageService.getImageSource(campaign.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                                alt="" />
                            <p class="m-0 ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                {{ campaign.campaignName }}</p>
                        </div>
                        <span
                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden"
                            aria-hidden="true">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                    </el-option>
                    }
                </el-options>
            </el-select>
            }
        </bb-field>
    </div>


    <bb-field label="Campaign goal">
        <div class="grid grid-cols-1 gap-3 sm:grid-cols-3">
            @for (goal of goals; track goal.id) {
            <bb-option-card [title]="goal.name" [description]="goal.description" [iconHtml]="goal.icon"
                [active]="service.selectedBriefGoal()?.id === goal.id" (selected)="selectGoal(goal)" />
            }
        </div>
    </bb-field>

    <!-- <bb-field label="Brief description">
      <textarea
        [value]="service.description()"
        (input)="service.description.set($any($event.target).value)"
        rows="3"
        placeholder="Set the scene for creators — what's the campaign about and why now?"
        class="w-full resize-y rounded-md border border-border bg-card px-3.5 py-2.5 text-base leading-relaxed outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground"></textarea>
    </bb-field> -->

    <div class="grid grid-cols-1 items-end gap-5 sm:grid-cols-2">
        <bb-field label="Creators needed">
            <bb-stepper class="w-full" label="creators needed" [value]="service.requiredCreators()" [min]="1"
                [max]="500" (valueChange)="service.requiredCreators.set($event)" />
        </bb-field>
        <div class="flex flex-wrap gap-2" role="group" aria-label="Quick select creators">
            @for (count of creatorCounts; track count) {
            <button type="button" [class]="creatorCountClass(count)" (click)="pickCreatorCount(count)">{{ count }}</button>
            }
        </div>
    </div>

</div>

@if (campaignStore.showCreateCampaignModal()) {
<create-campaign class="h-full w-full" (campaignCreated)="campaignStore.onCampaignCreated($event)"
    (close)="campaignStore.showCreateCampaignModal.set(false)"></create-campaign>
}